<template>
  <v-app id="app">
    <v-app-bar
        app
        color="#2E2D2C"
        dark
    >
      <div class="d-flex align-center">
        <v-img
            alt="Galliker Logo"
            class="shrink mr-2 gallLogo"
            id="resetButton"
            @click="changeToHome"
            contain
            src="./assets/gallikerLogo.png"
            transition="scale-transition"
            width="180"
        />
      </div>
    </v-app-bar>

    <v-main id="mainApp">
      <router-view :key="$route.fullPath" ref="view"> </router-view>
    </v-main>
    <v-footer
        padless
        color="#2E2D2C"
    >
      <v-col class="text-center footerText " cols="12">
        © {{ new Date().getFullYear() }} Galliker Transport AG
      </v-col>
    </v-footer>
  </v-app>
</template>

<script>
//import Search from './components/Search';

export default {
  name: 'App',

  components: {
   // Search
  },

  data: () => ({}),

  mounted() {
    /*if (this.$router.currentRoute.fullPath != "/") {
      this.changeToHome()
    }*/
  },

  methods: {
    changeToHome() {
      //call method in child component
      //change path only when not in home path
      if (this.$router.currentRoute.fullPath != "/") {
        //push to home path
        this.$router.push("/")
      }
    }
  }


};
</script>

<style>

</style>
